module.exports = __webpack_public_path__ + "img/part1.93e7f231.jpg";